import { render, staticRenderFns } from "./VoiceInput.vue?vue&type=template&id=46282aff&scoped=true"
import script from "./VoiceInput.vue?vue&type=script&lang=js"
export * from "./VoiceInput.vue?vue&type=script&lang=js"
import style0 from "./VoiceInput.vue?vue&type=style&index=0&id=46282aff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46282aff",
  null
  
)

export default component.exports